import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';

@Component({
  selector: 'app-anotacao-status-modal',
  templateUrl: './anotacao-status-modal.component.html',
  styleUrls: ['./anotacao-status-modal.component.scss']
})
export class AnotacaoStatusModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  anotacao = '';
  idCupom = '';

  constructor(public dialogRef: MatDialogRef<AnotacaoStatusModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService, private carregandoService: CarregandoService, private pedidoService: PedidoService) { }

  ngOnInit() {
    this.idCupom = this.data.idCupom;
    this.anotacao = this.data.anotacao;
  }

  salvar() {

    this.carregandoService.mostra('salvaProduto');

    this.pedidoService.atualizarAnotacaoStatus(this.idCupom, this.anotacao).subscribe(
      (retorno) => {

        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
        this.dialogRef.close({ anotacao: this.anotacao });
      },
      (erro) => {
        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
